import { IconOpenPreview } from '@components/icons/open-preview';
import { Menu } from '@components/menu';
import { useScopedTranslate } from '@locale/translate';

import { PreviewSmsProps, usePreviewSmsModal } from './preview-sms-modal';
import { previewSmsLocale } from './sms-preview';

// Disabled until its preview props resolve, so it never pops into an
// already-open menu (callers fetch lazily once the menu mounts it).
// Callers may also disable it (with a tooltip) while the action is unconfigured.
export const PreviewSmsMenuItemView = ({
  previewProps,
  isDisabled,
  tooltip,
}: {
  previewProps?: PreviewSmsProps;
  isDisabled?: boolean;
  tooltip?: string;
}) => {
  const { t } = useScopedTranslate(previewSmsLocale);
  const showPreviewModal = usePreviewSmsModal();

  return (
    <Menu.Item
      label={t('previewSms')}
      icon={<IconOpenPreview />}
      isDisabled={!previewProps || isDisabled}
      tooltip={tooltip}
      onSelect={() => previewProps && showPreviewModal(previewProps)}
    />
  );
};
